package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.tech.data.TechResponse
import org.moxultimate.topwithmox.techcrud.update.TechUpdatePage

/**
 * initTechUpdateRoute
 * Reconstructs a [TechResponse] from URL query params and adds it to the route data.
 * Called by Kobweb before the composable renders so the update page receives pre-populated data.
 *
 * @param ctx Kobweb route initialisation context.
 */
@InitRoute
fun initTechUpdateRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Edit Tech"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    val techResponse = TechResponse(
        id            = param(NavParams.ID).toLongOrNull() ?: 0L,
        title         = param(NavParams.TITLE),
        type          = param(NavParams.TYPE),
        tags          = param(NavParams.TAGS),
        description   = param(NavParams.DESCRIPTION),
        thumbnailPath = param(NavParams.THUMBNAIL_PATH),
        videoLink     = param(NavParams.VIDEO_LINK),
    )
    ctx.data.add(techResponse)
}

/**
 * TechUpdateRoute
 * Kobweb page entry point for the /techupdate route — renders [TechUpdatePage] with
 * the [TechResponse] reconstructed from URL params by [initTechUpdateRoute].
 */
@Page(routeOverride = "techupdate")
@Layout(".components.layouts.PageLayout")
@Composable
fun TechUpdateRoute() {
    val ctx = rememberPageContext()
    val techResponse = ctx.data.getValue<TechResponse>()
    TechUpdatePage(tech = techResponse)
}
